import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Document = ({
  width = 32,
  height = 32,
  className,
  filled,
  color,
  decorative = false,
  ariaLabel = "Document",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 32 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      {filled ? (
        <>
          <path
            fillRule="evenodd"
            d="M21.434 7.167 22.1 8l1 1.25.067.084H24.5a1.333 1.333 0 0 1 1.333 1.333V20H28.5v8c0 .737-.597 1.334-1.333 1.334H5.833A1.333 1.333 0 0 1 4.5 28v-8h2.667V4c0-.736.597-1.333 1.333-1.333h9.333L18.9 4l.267.334 1.04 1.301 1.227 1.532Zm2.933 4.75V20h-1.2v-9.416h1.2v1.333ZM20.392 8l-1.066-1.333-.16-.199V8h1.226ZM8.5 21.334H27.167V28H5.833v-6.666H8.5Z"
            clipRule="evenodd"
          />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M11.166 10.667h8V12h-8v-1.333Zm0 2.667h8v1.333h-8v-1.333Zm8 2.666h-8v1.334h8V16Z"
            clipRule="evenodd"
          />
        </>
      ) : (
        <path
          fillRule="evenodd"
          d="M17.833 2.667H8.5c-.736 0-1.333.597-1.333 1.333v16H4.5v8c0 .737.597 1.334 1.333 1.334h21.334c.736 0 1.333-.597 1.333-1.334v-8h-2.667v-9.333A1.333 1.333 0 0 0 24.5 9.334h-1.333zm6.534 7.917h-1.2V20h1.2zm-2.534-1.25H18.1a.267.267 0 0 1-.267-.267V4H8.5v16h13.333zm-16 12V28h21.334v-6.666zM19.167 6.468 20.392 8h-1.225zm-8 4.199V12h8v-1.333zm8 2.667v1.333h-8v-1.333zm0 2.666v1.334h-8V16z"
          clipRule="evenodd"
        ></path>
      )}
    </svg>
  );
};

